import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { fg } from '@atlaskit/platform-feature-flags';
import { convertMarkdownToProsemirror } from '@atlassian/ai-model-io/convert-markdown-to-prosemirror';
import { ErrorUtils } from '@atlassian/editor-ai-common/utils/errors';
export var enableComplexNodes = function enableComplexNodes() {
  if (!fg('platform_editor_ai_markdown_plus_add_complex_nodes')) {
    return false;
  }
  if (!fg('platform_editor_ai_proactive_ai_nudge')) {
    return false;
  }
  return true;
};
export function getPMFragmentWithFallback(_ref) {
  var markdown = _ref.markdown,
    schema = _ref.schema,
    source = _ref.source,
    fireAIAnalyticsEvent = _ref.fireAIAnalyticsEvent,
    idMap = _ref.idMap;
  try {
    var _convertMarkdownToPro = convertMarkdownToProsemirror({
        schema: schema,
        markdown: markdown,
        idMap: idMap,
        featureToggles: {
          markdownPlus: true,
          markdownPlusExtensions: true,
          markdownPlusPanels: true,
          markdownPlusDecisions: true,
          markdownPlusAttributeTest: fg('platform_editor_ai_markdown_plus_attr_test'),
          markdownPlusAddComplexNodes: enableComplexNodes()
        }
      }),
      pmFragment = _convertMarkdownToPro.pmFragment,
      htmlConvertedToFallbackNodes = _convertMarkdownToPro.htmlConvertedToFallbackNodes,
      htmlConvertedToNodes = _convertMarkdownToPro.htmlConvertedToNodes,
      markdownPlusAttributeStatus = _convertMarkdownToPro.markdownPlusAttributeStatus;
    if (markdownPlusAttributeStatus.length > 0 && fg('platform_editor_ai_markdown_plus_attr_test')) {
      markdownPlusAttributeStatus.forEach(function (status) {
        fireAIAnalyticsEvent({
          payload: {
            action: 'validateAttributes',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'markdownPlusAttributes',
            attributes: {
              attributesMatch: status[1],
              nodeType: status[0]
            },
            eventType: EVENT_TYPE.OPERATIONAL
          }
        });
      });
    }
    return {
      pmFragment: pmFragment,
      htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes,
      htmlConvertedToNodes: htmlConvertedToNodes,
      isTextFallbackUsed: false
    };
  } catch (error) {
    // When convertMarkdownToProsemirror a fragment
    // we log an analytics event to call out that markdown conversion has failed
    fireAIAnalyticsEvent({
      payload: {
        action: 'failed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'markdownParser',
        attributes: {
          source: source,
          errorType: 'markdownParser',
          errorMessage: ErrorUtils.extractErrorMessage(error)
        },
        eventType: EVENT_TYPE.OPERATIONAL
      }
    });

    // Instead of erroring, we fallback to rendering as plaintext in a single paragraph.
    var fallbackPMFragment = Fragment.from(schema.nodes.paragraph.create(null, schema.text(markdown)));
    return {
      pmFragment: fallbackPMFragment,
      htmlConvertedToFallbackNodes: 0,
      htmlConvertedToNodes: 0,
      isTextFallbackUsed: true
    };
  }
}